export default __webpack_public_path__ + "images/bytesize_db/logo-new-291971a60061e44452c6b2c559063541.png";